<section>
    <div class="container-fluid">
        <div class="row mb-1">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <div class="container-fluid">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">Home</li>
                        <li class="breadcrumb-item">Admin</li>
                        <li class="breadcrumb-item active">Search Theme Columns Assign</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="row mb-1">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 p-0">
            <div class="card Title-bar-blue">
                <div class="devcare-card-header">
                    <span class="devcare-sub-header Title-bar-text">Search Theme Columns Assign</span>
                </div>
                <div class="text-sm text-left">
                </div>
            </div>
        </div>
        <div class="col-sm-1"></div>
    </div>
</section>
<section>
    <div class="row mb-1">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 p-0">
            <div class="card vendor-company-profile">
                <div class="card-header">
                    <span class="card-title">Column Selection</span>
                </div><br>
                <div class="devcare-card-body">
                    <div class="row">
                        <div class="col-md-10">
                            <form>
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-6">
                                        <label for="searchPageName">Search Page <span
                                                class="required-field">*</span></label>
                                        <p-dropdown (onChange)="getSearchPageNameOnChange($event)"
                                            [options]="searchPageNamesList" placeholder="Select a Search Page"
                                            optionLabel="description" optionValue="lookupOrder"
                                            [(ngModel)]="searchPageNameLkId" [ngModelOptions]="{standalone: true}">
                                        </p-dropdown>

                                    </div>
                                    <div class="p-field p-col-12 p-md-6">
                                        <label for="theme">Theme<span
                                            class="required-field">*</span></label>
                                        <p-dropdown (onChange)="getSearchThemeNameOnChange($event)"
                                        [options]="searchPageThemesList" placeholder="Select a Theme"
                                        optionLabel="themeName" optionValue="themeId">
                                    </p-dropdown>
                                    </div>

                                </div>
                            </form>
                        </div>
                        <div class="col-md-2 d-flex align-items-center">
                            <button pButton pRipple type="button" [disabled] ="!themeSelected || !pageSelected" (click)="search()" label="Search" icon="pi pi-search"
                                class="p-button-sm p-button-raised p-button-success m-2"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row mb-1" *ngIf="showThemeColAssign">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 p-0">
            <div class="card vendor-company-profile">
                <div class="card-header">
                    <p><span >Note: </span>Drag and drop the columns needed for the selected theme.</p>
                </div>
                <div class="card-body vms-pick-list">
                    <!-- <div class="row">
                        <div class="col-md-6" pDroppable="selcolumns" (onDrop)="dropToAllColumns()">
                            <table class="table">
                                <thead
                                    style="box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2); margin-bottom:10px;">
                                    <tr class="background">
                                        <th style="color:white;">Available Columns</th>

                                    </tr>
                                </thead>
                                <tbody class="all-scroll my-custom-scrollbar table-wrapper-scroll-y">

                                    <div *ngFor="let column of availableColumns;let i = index" style="border: 1px solid #E9ECEF;"
                                        class="product-item jutify-content-between" pDraggable="columns"
                                        (onDragStart)="dragToSelectedColumns(column)"
                                        (onDragEnd)="dragEndSelectedColumns()" [pReorderableRow]="i">
                                        <div class="row"  pReorderableRowHandle>
                                            <div class="col-6">
                                                <th class="justify-content-end">{{ column.columnTitle }}
                                                </th>
                                            </div>
                                            <div class="col-6" style="text-align:right;">
                                                <i class="pi pi-ellipsis-v dev-icon column-icon"></i>
                                            </div>
                                        </div>


                                    </div>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-6" pDroppable="columns" (onDrop)="dropToSelectedColumns()">
                            <table class="table">
                                <thead
                                    style="box-shadow: 0 0 1px rgba(0, 0, 0, 0.125), 0 1px 3px rgba(0, 0, 0, 0.2); margin-bottom:10px;">
                                    <tr class="backgrounds">
                                        <th style="color:white;">Selected Columns</th>

                                    </tr>
                                </thead>
                                <tbody class="all-scroll my-custom-scrollbar table-wrapper-scroll-y">

                                    <div *ngFor="let selcolumn of selectedColumns" style="border: 1px solid #E9ECEF;"
                                        class="product-item" pDraggable="selcolumns"
                                        (onDragStart)="dragToAllColumns(selcolumn)" (onDragEnd)="dragEndAllColumns()">
                                        <div class="row">
                                            <div class="col-6">
                                                <th class="justify-content-end">{{ selcolumn.columnTitle }}
                                                </th>
                                            </div>
                                            <div class="col-6" style="text-align:right;">
                                                <i class="pi pi-ellipsis-v dev-icon column-icon"></i>
                                            </div>
                                        </div>

                                    </div>
                                </tbody>
                            </table>


                        </div>
                    </div> -->
                    <p-pickList [source]="availableColumns" [target]="selectedColumns" sourceHeader="Available Columns" targetHeader="Selected Columns"
                        [dragdrop]="true" [responsive]="true" [sourceStyle]="{'height':'30rem'}" [targetStyle]="{'height':'30rem'}"
                        [showSourceFilter]="false" [showTargetFilter]="false" [showSourceControls]="false" [showTargetControls]="false">
                        <ng-template let-column pTemplate="item">
                            <div class="">
                                {{column.columnTitle}}
                            </div>
                        </ng-template>
                    </p-pickList>
                </div>
                <div class="text-right" style="padding:15px;">
                    <button *ngIf="sharedService.checkPermission('Admin_Add')" pButton pRipple type="button" label="Save" [disabled]="!saveEnable" (click)="saveThemeColumnsAssign()"  [loading]="loadingSaveButton" icon="pi pi-check"
                        class="p-button-outlined p-button-success float-right m-2 bg-success"></button>
                </div>
            </div>
        </div>
    </div>
</section>
<p-toast position="bottom-center"></p-toast>